import React, {Fragment, useEffect} from 'react';

import '../../App.css';
import {Outlet, useMatches, useNavigate, useParams} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../feature/tools";
import {Button, Col, Flex, Modal, Row, Segmented, Space, Tooltip} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleLeft, faGrip, faList, faPlus} from "@fortawesome/free-solid-svg-icons";
import {AddChapterModal} from "./AddChapterModal";
import {Status} from "../../feature/project/status";
import {deleteChapter, fetchChapter, saveChapter} from "../../feature/project/chapterSlice";
import {Act, Chapter, Scene} from "../../feature/project/story";
import {ViewMode} from "../common/ViewMode";
import {useCookies} from "react-cookie";
import Scenes from "../scene/Scenes";
import {AddSceneModal} from "../scene/AddSceneModal";
import {fetchScenes, saveScene} from "../../feature/project/sceneSlice";
import {EntityDetails} from "../common/EntityDetails";
import Title from "antd/es/typography/Title";
import {editorRoles, WithUserPermission} from "../common/WithUserPermission";
const {confirm} = Modal

const ChapterDetails = () => {

    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const {actId, projectId, storyId, chapterId} = useParams()
    const matches = useMatches()
    const chapter = useAppSelector(state => state.chapters.chapter)
    const project = useAppSelector(state => state.projects.project)
    const status = useAppSelector(state => state.chapters.status)
    const sceneStatus = useAppSelector(state => state.scenes.status)
    const [modal, setModal] = React.useState(false)
    const [sceneModal, setSceneModal] = React.useState(false)

    useEffect(() => {
        if (projectId && chapterId && (status == Status.Idle || chapter?.id !== parseInt(chapterId))) {
            dispatch(fetchChapter({projectId: parseInt(projectId), chapterId: parseInt(chapterId)}))
        }
    }, [status, projectId, actId, dispatch])

    useEffect(() => {
        if (projectId && chapterId && (sceneStatus === Status.Idle || chapter?.id !== parseInt(chapterId))) {
            dispatch(fetchScenes({projectId: parseInt(projectId), chapterId: parseInt(chapterId)}))
        }
    }, [sceneStatus, projectId, storyId, dispatch])

    const showDeleteConfirm = () => {
        confirm({
            title: 'Delete Chapter',
            content: 'Are you sure you want to delete this chapter?',
            icon: <></>,
            okText: 'Yes, delete',
            okButtonProps: {danger: true, type: 'primary'},
            cancelText: 'No',
            onOk() {
                if (!chapterId || !projectId) return
                dispatch(deleteChapter({projectId: parseInt(projectId), chapterId: parseInt(chapterId)}))
                navigate(`/projects/${projectId}/stories/${storyId}/acts/${actId}`)
            },
        });
    };

    return (
        <Fragment>{
            matches[matches.length - 1].pathname.includes('/scenes') ? <Outlet/> : <>
                <Row style={{height: "100%"}}>
                    <Col span={chapter ? 16 : 24} style={{height: "100%"}}>
                        <Flex justify={'space-between'}>

                            <Space>
                                <Button type={'text'}
                                        onClick={() => navigate(`/projects/${projectId}/stories/${storyId}/acts/${actId}`)}
                                        icon={<FontAwesomeIcon icon={faAngleLeft}/>}/>
                                <Title level={4} style={{margin: 0}}>Scenes</Title>

                            </Space>
                            <WithUserPermission roles={editorRoles}>
                            <Space>
                                <Tooltip title="Add Scene">
                                    <Button icon={<FontAwesomeIcon icon={faPlus}/>} onClick={() => setSceneModal(true)}>Add
                                        Scene</Button>
                                </Tooltip>
                            </Space>
                            </WithUserPermission>
                        </Flex>
                        <Scenes />
                    </Col>
                    {chapter ? <Col span={8} style={{height: "100%"}}>
                        <EntityDetails
                            simple={true}
                            entity={chapter}
                            onDeleteClick={() => {
                                showDeleteConfirm()
                            }}
                            onEditClick={() => setModal(true)}
                        />
                    </Col> : ''}
                </Row>
                {chapter ?
                    <AddChapterModal
                        chapter={chapter}
                        visible={modal}
                        onCancel={() => setModal(false)}
                        onSave={(chapter: Chapter) => {
                            if (project) {
                                dispatch(saveChapter({projectId: project.id, chapter: chapter}))
                            }
                            setModal(false)
                        }}
                    /> : ''}
                <AddSceneModal
                    scene={{title: '', description: '', cover: '', tags: []}}
                    visible={sceneModal}
                    onCancel={() => setSceneModal(false)}
                    onSave={(scene: Scene) => {
                        if (project && chapterId) {
                            scene.chapterId = parseInt(chapterId)
                            dispatch(saveScene({projectId: project.id, scene: scene}))
                        }
                        setSceneModal(false)
                    }}
                />
            </>
        }
        </Fragment>
    );
};

export default ChapterDetails;